export const resources = {
  ViUploadConsentSubmitTerms: '',
  UploadOnlineServicesTerms: '',
  UploadServiceAgreement: '',
  UploadPrivacyStatement: '',
  UploadSubmitTermsTitle: '',
  UploadConsentUSSubmitTerms: '',
  UploadConsentUSSubmitTermsTitle: ''
};
